export default __webpack_public_path__ + "static/svg-sprite-5384ceeeed90241ba7a7224034f69e9f.svg";